module.exports = __webpack_public_path__ + "static/img/7241fecb89795a4640937c34f0fba89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs.jpg
// module id = GzX+
// module chunks = 1